import axios from "axios";
import { Socket } from "phoenix";

const DEFAULT_API_BASE_URL = "https://uagzambia-api-prod.afrocentec.com";
const normalizeBaseUrl = (value) => String(value || "").trim().replace(/\/+$/, "");
export const API_BASE_URL = normalizeBaseUrl(process.env.REACT_APP_API_BASE_URL) || DEFAULT_API_BASE_URL;
export const API_URL = `${API_BASE_URL}/api/`;

// API Extensions
const CLIENT_API_URL = `${API_URL}customer_users/`;
const COMPANY_API_URL = `${API_URL}company_users/`;
export const EMPLOYEE_DASHBOARD_API_URL = `${API_URL}emp_dash_users/`;

// Keep the company path defined for backwards compatibility with existing imports/usages.
void COMPANY_API_URL;

const isFormData = (value) => typeof FormData !== "undefined" && value instanceof FormData;

const getAccessToken = () => {
  const storedAccess = localStorage.getItem("access");

  if (!storedAccess)
  {
    return null;
  }

  try
  {
    return JSON.parse(storedAccess)?.access_token || null;
  } catch (error)
  {
    console.error("Failed to parse access token from localStorage.", error);
    return null;
  }
};

const buildHeaders = (data, includeAuth = true) => {
  const headers = { Accept: "application/json" };

  if (!isFormData(data))
  {
    headers["Content-Type"] = "application/json";
  }

  if (includeAuth)
  {
    const accessToken = getAccessToken();

    if (accessToken)
    {
      headers.Authorization = `Bearer ${accessToken}`;
    }
  }

  return headers;
};

const buildRequestConfig = (method, url, data, includeAuth = true) => {
  const config = {
    method,
    url,
    headers: buildHeaders(data, includeAuth),
  };

  if (isFormData(data))
  {
    config.transformRequest = [
      (payload, headers) => {
        if (headers)
        {
          if (typeof headers.delete === "function")
          {
            headers.delete("Content-Type");
          } else
          {
            delete headers["Content-Type"];

            if (headers.common)
            {
              delete headers.common["Content-Type"];
            }
          }
        }

        return payload;
      },
    ];
  }

  if (data)
  {
    if ((method || "").toLowerCase() === "get")
    {
      config.params = data;
    } else
    {
      config.data = data;
    }
  }

  return config;
};

// Client API Helper
export const makeClientApiRequest = (method, endpoint, data = null) => {
  return axios(buildRequestConfig(method, CLIENT_API_URL + endpoint, data));
};

// Employee Dashboard API Helper
export const makeEmployeeDashboardApiRequest = (method, endpoint, data = null) => {
  return axios(buildRequestConfig(method, EMPLOYEE_DASHBOARD_API_URL + endpoint, data));
};

// UnAuth API Helper
export const makeUnAuthApiRequest = (method, endpoint, data = null) => {
  return axios(buildRequestConfig(method, `${API_URL}${endpoint}`, data, false));
};

export const authSocketApiConnectionHelper = async () => {
  const token = getAccessToken();

  if (!token)
  {
    console.warn("No auth token found. Cannot establish socket connection.");
    return null;
  }

  const socket = new Socket(`${API_BASE_URL}/socket/auth`, {
    params: { token },
  });

  socket.connect();

  const isConnected =
    typeof socket.isConnected === "function"
      ? socket.isConnected()
      : socket.conn && socket.conn.readyState === 1;

  if (!isConnected)
  {
    console.warn("Socket not yet connected, waiting to open...");

    try
    {
      await new Promise((resolve, reject) => {
        const timeout = setTimeout(() => {
          reject(new Error("Socket connection timeout"));
        }, 5000);

        socket.onOpen(() => {
          clearTimeout(timeout);
          resolve(true);
        });

        socket.onError(() => {
          clearTimeout(timeout);
          reject(new Error("Socket connection failed"));
        });
      });
    } catch (error)
    {
      console.error("Failed to establish socket connection:", error.message);
      return null;
    }
  }

  return socket;
};
